import styled, { css } from 'styled-components';

export const Icon = styled.i<{ fontSize?: string }>`
	font-size: ${({ fontSize }) => fontSize || '24px'};
	vertical-align: middle;
	color: #595959;
`;

export const Header = styled.div`
	height: 20px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 0 10px;
	cursor: pointer;

	p {
		margin: 0;
		font-family: Roboto;
		font-size: 11px;
		line-height: 13px;
		color: #595959;
	}
`;

export const Item = styled.div<{ disabled?: boolean }>`
	height: 30px;
	display: flex;
	align-items: center;
	gap: 6px;
	padding: 0 10px;
	cursor: pointer;

	:hover {
		background-color: #f2f9ff;
	}

	${({ disabled }) =>
		disabled &&
		css`
			/* cursor: not-allowed; */
			pointer-events: none;
			opacity: 0.5;
		`};

	p {
		margin: 0;
		font-family: Roboto;
		font-size: 12px;
		line-height: 14px;

		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}
`;

export const ImageIcon = styled.img`
	width: 24px;
	height: 24px;
`;

export const Group = styled.div`
	${Item}:not(:last-child) {
		margin-bottom: 6px;
	}

	height: auto;
	max-height: 0;
	overflow: hidden;

	&.expanded {
		max-height: 100%;
	}

	transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
	/* overflow-y: auto; */
`;

export const Wrapper = styled.div<{ expanded?: boolean }>`
	padding: 8px 0px;
	display: flex;
	flex-direction: column;
	border-top: 1px solid #e5e5e5;

	${Header} {
		margin-bottom: ${({ expanded }) => (expanded ? '6px' : '0')};
	}
`;
